import { ActionStatus } from "../../../common/constants/action-status";
import { StoreState } from "../../../store/store.interface";
import { RmsBookstoreAddress } from "../../checkout/shop-checkout.interface";
import { AddressBookResponse } from "../interfaces/address-book.interface";

/*----- CREATE SELECTORS ------*/

export const getAddressBookResponse = (state: StoreState, type: string) => getAddressBook(state, type);
export const getLastAddressResponse = (state: StoreState, type: string) => getLastAddress(state, type);
export const getAddressBookStatus = (state: StoreState) => state.addressBook.status;
export const isLoadingAddressBook = (state: StoreState) => state.addressBook.status === ActionStatus.loading;
export const isSuccessAddressBook = (state: StoreState) => state.addressBook.status === ActionStatus.succeeded;
export const isRejectedAddressBook = (state: StoreState) => state.addressBook.status === ActionStatus.failed;

function getAddressBook(state: StoreState, type: string) {
  const data = state.addressBook.data as AddressBookResponse;
  let addressBook;
  if(data){
    if (type === "shipping" && data.shippingAddresses && data.shippingAddresses.length > 0){
      addressBook = data.shippingAddresses;
      return addressBook;
    } else if (type === "billing" && data.billingAddresses && data.billingAddresses.length > 0) {
      addressBook = data.billingAddresses;
      return addressBook;
    }
  }
  return [];
}

function getLastAddress(state: StoreState, type: string) {
  const addresses = state.addressBook.data as RmsBookstoreAddress[];
  if (addresses) {
    return addresses.find( (address: any) => address.addressType === type);
  } else {
    return;
  }
}
